import '../styles/main.scss';
import { Application } from "stimulus";

// Stimulus controllers
import BodyController from './controllers/body_controller';

const application = Application.start();
application.register('body', BodyController);
